import React, { useState, useEffect, useRef } from "react";
import { withNamespaces } from "react-i18next";
import axios from "axios";
import CreateEditRole from "./CreateEditRole.js";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const RolesList = (props) => {
  let roles = props.data;
  let rolesAndRightsUI = props.dataUI;
  let link = localStorage.getItem("link");
  let activeRights = JSON.parse(localStorage.getItem("rights"));
  let canCreate = activeRights.includes("Roles.Create");
  let canEdit = activeRights.includes("Roles.Update");
  let canDel = activeRights.includes("Roles.Delete");

  const [popUpShow, setPopUpShow] = useState(false);
  const [currentRoleData, setCurrentRoleData] = useState();

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  function editCreateRole(roleData) {
    setCurrentRoleData(roleData);
    setPopUpShow(true);
  }

  const deleteRole = (roleData) => {
    let id = roleData.roleID;

    confirmAlert({
      message: props.t("allgemein.bestaetigen"),
      buttons: [
        {
          label: props.t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(link + "/api/RolesAndRights?roleID=" + id)
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: props.t("allgemein.nein"),
        },
      ],
    });
  };

  function rolesList() {
    let rolesList = [];

    for (let i = 0; i < roles.length; i++) {
      rolesList.push(
        <tr key={"key_" + i}>
          <td>{roles[i].roleName}</td>
          <td>
            {canEdit && (
              <i
                className="bx bx-edit bx-sm"
                style={{ marginLeft: "10px" }}
                onClick={() => editCreateRole(roles[i])}
                title={props.t("allgemein.Bearbeiten")}
              ></i>
            )}
            {!roles[i].isPersistent && canDel && !roles[i].assignedToUsers && (
              <i
                className="bx bx-trash bx-sm"
                style={{ marginLeft: "10px" }}
                onClick={() => deleteRole(roles[i])}
                title={props.t("allgemein.Loeschen")}
              ></i>
            )}
          </td>
        </tr>
      );
    }

    return <tbody>{rolesList}</tbody>;
  }

  function popUpChange() {
    props.onChange();
    setPopUpShow(false);
  }

  return (
    <>
      {popUpShow == true && (
        <div style={{ width: "80%", margin: "auto" }}>
          {
            <CreateEditRole
              type={"rolesAndRights"}
              data={currentRoleData}
              dataUI={rolesAndRightsUI}
              onChange={popUpChange}
            >
              {" "}
            </CreateEditRole>
          }
        </div>
      )}
      {popUpShow == false && (
        <div style={{ width: "50%", margin: "auto" }}>
          <h3>{props.t("administration.manageRolesAndRights")}</h3>
          <div className="box-name">
            {props.t("administration.manageRolesAndRights")}
          </div>
          <div style={{ overflow: "auto" }}>
            <table id="manageRolesAndRightsTable">
              <thead>
                <tr>
                  <th>{props.t("allgemein.name")}</th>
                  <th>
                    {canCreate && (
                      <button
                        className="button"
                        id="pop-up-button"
                        style={{ width: "80px" }}
                        onClick={() => editCreateRole()}
                      >
                        {props.t("allgemein.Neu")}
                      </button>
                    )}
                  </th>
                </tr>
              </thead>
              {rolesList()}
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default withNamespaces()(RolesList);
